module.exports = __webpack_public_path__ + "static/media/leicester-simulations.6ab50040.jpg";